import { render, staticRenderFns } from "./myShoppingCart.vue?vue&type=template&id=4d2bb67e&scoped=true&"
import script from "./myShoppingCart.vue?vue&type=script&lang=js&"
export * from "./myShoppingCart.vue?vue&type=script&lang=js&"
import style0 from "./myShoppingCart.vue?vue&type=style&index=0&id=4d2bb67e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2bb67e",
  null
  
)

export default component.exports